import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { ServiceHomeSecurity } from '@magalu/stereo-ui-icons';
import { Link, CertificatePartners, LinksNav } from './footer.styles';
export const renderCertificatePartnersTitle = (_ref = {}, onCertificateClick) => {
  let {
    url,
    title,
    label
  } = _ref,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["url", "title", "label"]);

  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement(CertificatePartners.Title, _extends({
    "data-testid": "certificates-title",
    title: title,
    href: url
  }, otherProps, {
    onClick: e => onCertificateClick(e, {
      url,
      title,
      label
    })
  }), /*#__PURE__*/React.createElement(ServiceHomeSecurity, {
    "data-testid": "certificates-title-icon",
    color: "currentColor"
  }), label && /*#__PURE__*/React.createElement(CertificatePartners.TitleLabel, {
    "data-testid": "certificates-title-label"
  }, label)));
};
export const renderLinkContent = ({
  url,
  title,
  gap,
  content = [],
  linkAttrs = {}
}, onEventAction = () => {}) => {
  return /*#__PURE__*/React.createElement(Link, _extends({
    "data-testid": "link-item",
    href: url,
    title: `Link para: ${title}`,
    px: "10px"
  }, linkAttrs), content.map((_ref2, i) => {
    let {
      label,
      img
    } = _ref2,
        styledProps = _objectWithoutPropertiesLoose(_ref2, ["label", "img", "iconId"]);

    return /*#__PURE__*/React.createElement(LinksNav.Content, {
      "data-testid": `link-item-children-${i}`,
      key: i,
      gap: gap,
      onClick: e => onEventAction(e, {
        url,
        title
      })
    }, label && /*#__PURE__*/React.createElement(LinksNav.Text, styledProps, label), img && /*#__PURE__*/React.createElement(LinksNav.Image, _extends({
      src: img,
      alt: title
    }, styledProps)));
  }));
};